import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Value extends Component {
  static propTypes = {
    children: PropTypes.any,
  };

  render() {
    const { children, className } = this.props;

    return <span className={className}>{children}</span>;
  }
}
